module.exports = __webpack_public_path__ + "mv.svg?3d599ae09c7c4a539b7552eec503ba73";